import { Link } from 'react-router-dom'

interface Breadcrumb<TState = unknown> {
  label: string
  path?: string
  state?: TState
}

interface BreadcrumbProps<TState = unknown> {
  pageName: string
  breadcrumbs: Breadcrumb<TState>[]
}

const Breadcrumbs = <TState,>({ pageName, breadcrumbs }: BreadcrumbProps<TState>) => {
  return (
    <div className="mb-6 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
      <h2 className="text-title-md2 font-semibold text-black dark:text-white">
        {pageName}
      </h2>

      <nav>
        <ol className="flex items-center gap-2">
          {breadcrumbs.map((crumb, index) => (
            <li key={index} className="flex items-center">
              {crumb.path ? (
                <Link to={crumb.path}
                      state={crumb.state}
                      className="font-medium">
                  {crumb.label}
                </Link>
              ) : (
                <span className="font-medium text-primary">{crumb.label}</span>
              )}
              {/* Separator unless it's the last crumb */}
              {index < breadcrumbs.length - 1 && (
                <span className="mx-2">/</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </div>
  )
}

export default Breadcrumbs
